import CheckBox from 'devextreme-react/check-box';
import List from 'devextreme-react/list';
import React, { useEffect, useMemo, useReducer, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import { Loader } from "semantic-ui-react";
import { hinhThucMienGiamApi } from '../../../api/hinhthucmiengiam_api';
import ComboboxNamHoc from '../../../components/editor/cmb_namhoc';
import { useCommonContext, HttpMethod } from "../../../contexts/common";
import { showNotify } from "../../../helpers/toast.js";
import { action_type, ini_state, reducer } from './reduce';
import { PrimaryButton } from '../../../components/editor/button';


const HinhThucMienGiam = ({ hocSinh, onCancel }) => {
  const { dm_coso_id } = useSelector(x => x.coSo);
  const { nam_hoc } = useSelector(x => x.namHoc);
  const [nam_hoc_selected, set_nam_hoc_selected] = useState();
  const [is_saving, set_is_saving] = useState(false);
  const [list_dm_namhoc, set_list_dm_namhoc] = useState();
  const [default_nam_hoc, set_default_nam_hoc] = useState();
  const { register, trigger, errors, clearErrors } = useForm();
  const { canAccessTo, translate } = useCommonContext();
  const [state, dispatch] = useReducer(reducer, ini_state);
  const handleSaveChanges = async (datas) => {
    if (hocSinh.id > 0) {
      let id_miengiam_select = [];
      state.list_miengiam_select.forEach(element => {
        id_miengiam_select.push(element.id);
      });
      let adds = [];
      state.list_miengiam_adds.forEach(element => {
        adds.push(element.id);
      });
      const list_miengiam_dels = id_miengiam_select.filter((val) => !adds.includes(val));
      const list_miengiam_adds = adds.filter((val) => !id_miengiam_select.includes(val));
      await hinhThucMienGiamApi.InsertAsync({ id: hocSinh.id, nam_hoc: nam_hoc_selected, sf_hinhthucmiengiam_ids: list_miengiam_adds });
      await hinhThucMienGiamApi.DeleteAsync({ id: hocSinh.id, nam_hoc: nam_hoc_selected, sf_hinhthucmiengiam_ids: list_miengiam_dels });
      showNotify({
        text: translate('Cập nhật thông tin thành công.'),
        type: "success",
      });
    }
  };

  useEffect(() => {
    set_nam_hoc_selected(nam_hoc);
  }, [nam_hoc]);

  useEffect(() => {
    get_list_miengiam_by_hocsinh(hocSinh.id, nam_hoc_selected);
    get_list_miengiam(hocSinh.id, nam_hoc_selected);
  }, [nam_hoc_selected]);






  // useEffect(() => {
  //   set_nam_hoc_selected(nam_hoc);
  //   get_list_dm_namhoc();
  //   clearErrors();
  // }, [nam_hoc_selected]);

  // const get_list_dm_namhoc = async () => {
  //   const res = await namHocAPi.SelectAll();
  //   if (res.is_success) {
  //     set_list_dm_namhoc(res.data);
  //     var nam_hoc = res.data?.find((x) => x.is_default == true).nam_hoc;
  //     set_default_nam_hoc(nam_hoc);
  //     get_list_miengiam_by_hocsinh(hocSinh.id, nam_hoc);
  //     get_list_miengiam(hocSinh.id, nam_hoc);
  //   }
  // };

  const get_list_miengiam = async (id, nam_hoc) => {
    const res = await hinhThucMienGiamApi.SelectByNamHocAsync(nam_hoc, id, dm_coso_id);
    if (res.is_success) {
      if (res.is_success) {
        dispatch({
          type: action_type.SET_MIEN_GIAMS,
          payload: res.data,
        });
      }
    } else {
      dispatch({
        type: action_type.SET_MIEN_GIAMS,
        payload: [],
      });
    }
  };

  const get_list_miengiam_by_hocsinh = async (id, nam_hoc) => {
    const res = await hinhThucMienGiamApi.SelectByHocSinhAsync(nam_hoc, id);
    if (res.is_success && res.data != undefined) {
      dispatch({
        type: action_type.SELECT_MIENGIAM_BY_HOCSINH,
        payload: res.data,
      });
    }
  };


  const _list_uudai = useMemo(() => {
    const _list = state.list_miengiam.reduce((prevVal, current) => {
      if (!prevVal[current.nhom_mien_giam.toString().normalize()]) {
        prevVal[current.nhom_mien_giam.toString().normalize()] = {
          key: current.nhom_mien_giam.toString(),
          items: [current]
        }
      } else {
        prevVal[current.nhom_mien_giam.toString().normalize()] = {
          key: current.nhom_mien_giam.toString(),
          items: [...prevVal[current.nhom_mien_giam.toString().normalize()].items, current]
        }
      }
      return prevVal
    }, {})
    return Object.values(_list);
  }, [state.list_miengiam])

  const groupRender = (item) => {
    return <div style={{ paddingLeft: '10px', color: 'rgba(0,0,0,.54)', fontWeight: 'bold' }}>{translate('Nhóm miễn giảm')}: {item.key}</div>;
  }

  const ItemTemplate = (data) => {
    return <div style={{ display: 'flex', minHeight: '30px', paddingLeft: '10px', flexDirection: 'row', alignItems: 'center', }}>
      <CheckBox
        stylingMode="outlined"
        onValueChanged={(e) => {
          if (e.value) {
            dispatch({ type: action_type.CHANGE_MIENGIAM, payload: data });
          } else {
            dispatch({ type: action_type.DELETE_MIENGIAM, payload: data });
          }

        }}
        value={state.list_miengiam_adds.find((val) => val.id === data.id) ? true : false}
      />
      <div
        key={data.id}
        style={{ paddingLeft: '20px', display: 'flex', flex: 1 }}
      >
        <p className="name-item" style={{ width: '30%', margin: 'auto', wordWrap: 'break-word', whiteSpace: 'break-spaces', paddingRight: '15px' }}>{data.ma_hinh_thuc}</p>
        <p className="name-item" style={{ width: '70%', margin: 'auto', wordWrap: 'break-word', whiteSpace: 'break-spaces' }}>{data.hinh_thuc_mien_giam}</p>
      </div>

    </div>;
  }

  return (
    <>
      <form className="ui">
        <div className="row">
          <div className="col-md-3">
            <div className="dx-field-label">{translate('Năm học')}</div>
            <br></br>
            {/* <SelectBox
              stylingMode="outlined"
              // defaultValue={default_nam_hoc}
              value={nam_hoc_selected}
              dataSource={list_dm_namhoc}
              displayExpr="nam_hoc"
              valueExpr="nam_hoc"
              noDataText="Không có dữ liệu"
              onValueChanged={(e) => {
                if (e.event) {
                  set_nam_hoc_selected(e.value);
                  // get_list_miengiam(hocSinh.id, e.value);
                }
              }}
            /> */}

            <ComboboxNamHoc
              stylingMode='outlined'
              value={nam_hoc_selected}
              // readOnly = 'true'
              onValueChanged={(value) => {
                set_nam_hoc_selected(value);
              }}
            />
          </div>
          <List
            className="uu-dai-list"
            dataSource={_list_uudai}
            height={window.innerHeight - 300}
            itemRender={ItemTemplate}
            collapsibleGroups={true}
            groupRender={groupRender}
            grouped={true}
            selectionMode="single"
          />
        </div>

      </form>
      <div
        className="row"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: 20,
          marginRight: 20,
        }}
      >
        {/* {canAccessTo('hinhthucmiengiam/insert_de_xuat_mien_giam' , HttpMethod.POST) &&  */}
        <PrimaryButton onClick={handleSaveChanges} icon={"fas fa-save"} text={"Cập nhật"} isLoading={is_saving}>
        </PrimaryButton>
        {/* } */}

        {/* <button
          disabled={is_saving}
          onClick={handleSaveChanges}
          style={{ marginLeft: "10px" }}
          className="p-btn p-prim-col p-btn-sm margin-left-10"
        >
          {"Cập nhật"}
          {is_saving && <Loader active inline size="mini" />}
        </button> */}
      </div>
    </>
  );
};

export default HinhThucMienGiam;
